const en = {
  // ── Navbar ──
  "nav.home": "Home",
  "nav.aviation": "Aviation News",
  "nav.hotels": "Hotels",
  "nav.destinations": "Destinations",
  "nav.videos": "Videos",
  "nav.gcc": "GCC Guide",
  "nav.opinion": "Opinion",
  "nav.about": "About Us",
  "nav.advertise": "Advertise",
  "nav.contact": "Contact Us",
  "nav.pdfEdition": "AlSiyahiah PDF",
  "nav.search": "Search news...",
  "nav.searchResults": "Quick results",
  "nav.searchAll": "View all results for",
  "nav.searchEmpty": "No results for",
  "nav.searchFull": "Full search",
  "nav.searchLoading": "Searching...",
  "nav.langToggle": "AR",
  "nav.topBarDate": "Wednesday, April 22, 2026",
  "nav.topBarSlogan": "The Gulf\'s Leading Tourism Newspaper",
  "nav.breaking": "Breaking",
  "nav.breakingText": "Dubai Airport welcomes 92 million passengers in 2025 ← Saudi Tourism Ministry announces 40 new destinations ← Qatar to host World Tourism Conference 2027 ← UAE wins Best Arab Tourism Destination for third consecutive year ←",

  // ── Footer ──
  "footer.followUs": "Follow us on",
  "footer.about": "A daily online newspaper specialising in travel and tourism news across the Gulf region and beyond.",
  "footer.location": "Manama, Kingdom of Bahrain",
  "footer.newsTitle": "News Sections",
  "footer.specialTitle": "Special Sections",
  "footer.contactTitle": "Contact Us",
  "footer.phone": "+973 3911 7226",
  "footer.whatsapp": "+973 3637 0441 (WhatsApp)",
  "footer.newsEmail": "news@alsiyahiah.com",
  "footer.newsEmailLabel": "Editorial & News",
  "footer.workHours": "Sun – Thu: 8 AM – 8 PM",
  "footer.copyright": "© 2026 Al-Siyahiah Newspaper – All rights reserved",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.policy": "Publishing Policy",
  "footer.ads": "Advertising",
  "footer.news.aviation": "Aviation & Airports",
  "footer.news.hotels": "Hotels & Resorts",
  "footer.news.destinations": "Tourism Destinations",
  "footer.news.culture": "Cultural Tourism",
  "footer.news.family": "Family Entertainment",
  "footer.news.tech": "Travel Technology",
  "footer.news.reports": "Reports & Statistics",
  "footer.special.reports": "Reports & Analysis",
  "footer.special.gcc": "GCC Tourism Guide",
  "footer.special.events": "Exhibitions & Events",
  "footer.special.sports": "Sports Tourism",
  "footer.special.infographics": "Tourism Infographics",
  "footer.special.about": "About Us",
  "footer.special.advertise": "Advertise With Us",

  // ── Hero Slider ──
  "hero.readMore": "Read Full Story",

  // ── Trending News ──
  "trending.title": "Most Read",
  "trending.viewAll": "View All News",

  // ── Latest News ──
  "latest.title": "Latest News",
  "latest.archive": "News Archive",
  "latest.readMore": "Read More",
  "latest.readTime": "read",

  // ── Featured Destinations ──
  "destinations.title": "Top Tourism Destinations",
  "destinations.subtitle": "Latest tourism news and updates from the region",
  "destinations.gccGuide": "GCC Guide",
  "destinations.news": "articles",

  // ── Hotels Section ──
  "hotels.title": "Hotels & Resorts News",
  "hotels.tab1": "Hotel News",
  "hotels.tab2": "Openings",
  "hotels.tab3": "Reviews",
  "hotels.more": "More",
  "hotels.viewMore": "View More Hotel News",
  "hotels.read": "Read",

  // ── Featured Videos ──
  "videos.title": "Featured Videos",
  "videos.subtitle": "Exclusive reports and footage from top destinations",
  "videos.playlist": "Playlist",
  "videos.viewAll": "All Videos",
  "videos.browseAll": "Browse All Videos",
  "videos.views": "views",
  "videos.stat1": "Exclusive Videos",
  "videos.stat2": "Total Views",
  "videos.stat3": "Locations Filmed",
  "videos.sectionBadge": "Video Section",
  "videos.heroLine1": "Tourism Reports",
  "videos.heroLine2": "Visual & Exclusive",
  "videos.heroSubtitle": "Field tours, exclusive reports, and footage from the top tourist destinations in the Gulf and the world",
  "videos.searchPlaceholder": "Search videos...",
  "videos.allVideos": "All Videos",
  "videos.searchResults": "Search Results",
  "videos.countLabel": "{{count}} videos",
  "videos.noResults": "No videos match your search",
  "videos.statPublished": "Published Videos",
  "videos.statTotalViews": "Total Views",
  "videos.statContent": "Visual Content",
  "videos.statLocations": "Locations Filmed",

  // ── GCC Banner ──
  "gcc.label": "GCC TOURISM GUIDE",
  "gcc.title": "The Complete GCC Tourism Guide",
  "gcc.desc": "Comprehensive news coverage of the tourism industry across all six Gulf Cooperation Council countries — from news and reports to hotel guides, landmarks and restaurants.",
  "gcc.tag1": "Latest News",
  "gcc.tag2": "Hotel Guide",
  "gcc.tag3": "Tourist Attractions",
  "gcc.tag4": "Events",
  "gcc.cta": "Explore Full Guide",
  "gcc.news": "articles",
  "gcc.readCoverage": "Read Coverage →",

  // ── Opinion / Reports ──
  "opinion.title": "Reports & Analysis",
  "opinion.viewAll": "All Reports",

  // ── News Categories ──
  "categories.title": "Browse by Category",
  "categories.all": "All",
  "categories.news": "articles",
  "categories.name.aviation": "Aviation & Airports",
  "categories.name.hotels": "Hotels & Resorts",
  "categories.name.destinations": "Tourism Destinations",
  "categories.name.culture": "Culture & Arts",
  "categories.name.tech": "Travel Technology",
  "categories.name.sports": "Sports Tourism",
  "categories.name.events": "Exhibitions & Events",
  "categories.name.reports": "Reports & Statistics",
  "categories.name.family": "Family Entertainment",
  "categories.name.realestate": "Tourism Real Estate",
  "categories.name.eco": "Eco Tourism",

  // ── Newsletter ──
  "newsletter.badge": "NEWSLETTER",
  "newsletter.title": "Stay Updated on the Latest Tourism News",
  "newsletter.desc": "Subscribe to our weekly newsletter and get the top travel and tourism stories from the Gulf and around the world delivered straight to your inbox.",
  "newsletter.placeholder": "Enter your email address",
  "newsletter.submit": "Subscribe Free",
  "newsletter.loading": "...",
  "newsletter.successTitle": "Successfully Subscribed!",
  "newsletter.successDesc": "Your weekly newsletter arrives every Wednesday morning.",
  "newsletter.stat1": "+85,000 subscribers",
  "newsletter.stat2": "Weekly every Wednesday",
  "newsletter.stat3": "We\'ll never share your data",

  // ── Translator ──
  "translator.english": "English",
  "translator.arabic": "العربية",
  "translator.switchToEnglish": "Translate page to English",
  "translator.switchToArabic": "Return to Arabic",

  // ── Common Static UI ──
  "common.allNews": "All News",
  "common.readMore": "Read More",
  "common.viewAll": "View All",
  "common.view": "View",
  "common.featured": "Featured",
  "common.sort": "Sort",
  "common.articleCount": "{{count}} articles",
  "common.like": "Like",
  "common.views": "views",
  "common.viewsCount": "{{count}} views",
  "common.minutes": "{{count}} min",
  "common.editorialTeam": "Editorial Team",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.callNow": "Call Now",
  "common.back": "Back",
  "common.read": "Read",
  "common.cancel": "Cancel",
  "common.optional": "optional",
  "common.noResults": "No results",

  // ── Share UI ──
  "share.label": "Share:",
  "share.article": "Share article:",
  "share.place": "Share this place",
  "share.video": "Share this video",
  "share.share": "Share",
  "share.copyLink": "Copy link",
  "share.copy": "Copy",
  "share.copied": "Copied!",
  "share.likedPrompt": "Enjoyed the article? Share it with your friends",

  "social.instagram": "Instagram",
  "ads.label": "Advertisement",

  // ── SEO / Home Static Sections ──
  "seo.home.title": "Al Siyahiah - Gulf Tourism Media Platform | Travel and Tourism News",
  "seo.home.description": "Al Siyahiah is the Gulf's leading tourism media platform. Follow the latest tourism and travel news, Gulf destinations, hotel offers and aviation updates for 2026.",
  "seo.home.keywords": "Al Siyahiah, tourism news, travel, Gulf, hotels, tourist destinations, travel deals, aviation",
  "home.heroFallback.1.category": "Tourism",
  "home.heroFallback.1.title": "Welcome to Al Siyahiah",
  "home.heroFallback.1.description": "The Gulf's leading tourism media platform, covering travel news and Gulf destinations.",
  "home.heroFallback.2.category": "Destinations",
  "home.heroFallback.2.title": "Discover the Gulf's Most Beautiful Destinations",
  "home.heroFallback.2.description": "From Dubai to Muscat, explore the region's most remarkable cities and travel experiences.",
  "home.heroFallback.3.category": "Hotels",
  "home.heroFallback.3.title": "The Best Luxury Gulf Hotels for 2026",
  "home.heroFallback.3.description": "A practical guide to leading hotels and resorts across the Arabian Gulf, including the latest offers.",
  "home.breakingFallback.1": "Dubai Airport welcomes 92 million passengers in 2025",
  "home.breakingFallback.2": "Saudi Tourism Ministry announces 40 new tourism destinations",
  "home.breakingFallback.3": "Qatar to host the World Tourism Conference 2027",
  "home.breakingFallback.4": "UAE wins Best Arab Tourism Destination for the third year in a row",
  "home.aviation.title": "Aviation News",
  "home.aviation.subtitle": "Latest updates from airlines, airports and new destinations",
  "home.travelTips.title": "Travel Tips",
  "home.travelTips.subtitle": "Guidance and advice for a better tourism trip",

  // ── Destination Static UI ──
  "destinations.newsTitle": "Tourism Destination News",
  "destinations.newsSubtitle": "Discover the most beautiful destinations and latest updates across the Gulf and the world",
  "destinations.sortMost": "Most News",
  "destinations.sortLeast": "Least News",
  "destinations.sortAlpha": "Alphabetical",
  "destinations.dragHint": "Swipe left or right to browse",
  "destinations.exploreAll": "Explore All News",
  "cities.dubai": "Dubai",
  "cities.riyadh": "Riyadh",
  "cities.muscat": "Muscat",
  "cities.doha": "Doha",
  "cities.manama": "Manama",
  "cities.kuwait": "Kuwait",
  "countries.uae": "UAE",
  "countries.saudi": "Saudi Arabia",
  "countries.oman": "Oman",
  "countries.qatar": "Qatar",
  "countries.bahrain": "Bahrain",
  "countries.kuwait": "Kuwait",

  // ── Other Home Static UI ──
  "hero.exploreContent": "Explore Content",
  "trending.sortedByViews": "Sorted by views",
  "infographics.title": "Infographics",
  "infographics.subtitle": "Visual data and statistics",
  "infographics.browseAll": "Browse All Infographics",
  "opinion.articlesTitle": "Opinion Articles",
  "opinion.articleCount": "{{count}} articles",
  "opinion.viewAllArticles": "View All Opinion Articles",
  "videos.local": "Local",
  "gcc.stat.hotel": "Hotel",
  "gcc.stat.restaurant": "Restaurant",
  "gcc.stat.destination": "Destination",
  "gcc.exploreCountry": "Explore {{country}}",
  "gcc.stats.countries": "Gulf Countries",
  "gcc.stats.hotels": "Hotels and Resorts",
  "gcc.stats.restaurants": "Restaurants and Cafes",
  "gcc.stats.destinations": "Tourist Destinations",

  // ── Brand / Common ──
  "brand.name": "Al Siyahiah",
  "brand.fullName": "Al Siyahiah Newspaper",
  "brand.newspaperName": "Al Siyahiah Newspaper",
  "common.news": "News",
  "common.backHome": "Back to Home",
  "common.close": "Close",
  "common.previous": "Previous",
  "common.next": "Next",
  "common.other": "Other",
  "common.unavailable": "Unavailable",
  "common.loadingShort": "Loading...",
  "common.tryAgainError": "Something went wrong. Please try again.",
  "common.scrollToTop": "Back to top",
  "categories.count": "{{count}} articles",
  "share.whatsapp": "WhatsApp",
  "share.facebook": "Facebook",
  "share.telegram": "Telegram",
  "share.twitter": "Twitter / X",

  // ── Not Found / Errors ──
  "notFound.title": "Page Not Found",
  "notFound.description": "The page may have been removed or its link changed. You can return to the homepage or browse the site sections.",
  "notFound.home": "Back to Home",
  "notFound.search": "Search the Site",
  "errorBoundary.pageTitle": "Something Went Wrong",
  "errorBoundary.pageDescription": "Sorry for the interruption. You can try again or return to the homepage.",
  "errorBoundary.details": "Error Details",
  "errorBoundary.retry": "Try Again",
  "errorBoundary.home": "Homepage",
  "errorBoundary.sectionTitle": "This section could not be loaded",
  "errorBoundary.sectionDescription": "An error occurred while rendering the content",

  // ── Infographics Page ──
  "seo.infographics.title": "Tourism Infographics | Al Siyahiah - Visual Data and Statistics",
  "seo.infographics.description": "Specialized tourism infographics with visual data and statistics about tourism in the Gulf and the Arab world.",
  "seo.infographics.keywords": "infographics, tourism, statistics, data, Gulf",
  "infographics.searchPlaceholder": "Search infographics...",
  "infographics.noResultsTitle": "No Results",
  "infographics.noResultsDescription": "Try changing the filter or search term",
  "infographics.allTitle": "All Infographics",
  "infographics.shareTitle": "Share infographic",
  "infographics.download": "Download Infographic",
  "infographics.heroTitle": "Tourism Infographics",
  "infographics.heroDescription": "Specialized visual data and statistics for the tourism and travel sector in the Gulf and the Arab world",
  "infographics.stats.infographics": "Infographics",
  "infographics.categories.all": "All",
  "infographics.categories.statistics": "Statistics",
  "infographics.categories.destinations": "Destinations",
  "infographics.categories.hotels": "Hotels",
  "infographics.categories.aviation": "Aviation",
  "infographics.categories.seasonal": "Seasonal",
  "infographics.categories.religious": "Religious",
  "infographics.categories.eco": "Eco",

  // ── Contact Page ──
  "seo.contact.title": "Contact Us - Al Siyahiah Newspaper",
  "seo.contact.description": "Contact the Al Siyahiah team. We welcome your enquiries, suggestions and media partnership requests.",
  "seo.contact.keywords": "contact us, contact, Al Siyahiah, tourism media, Gulf",
  "contact.title": "Contact Us",
  "contact.subtitle": "We welcome your messages. The Al Siyahiah team is ready to answer your enquiries, receive your suggestions and discuss partnership requests.",
  "contact.infoTitle": "Contact Information",
  "contact.email": "Email",
  "contact.phone": "Phone",
  "contact.whatsapp": "WhatsApp",
  "contact.address": "Address",
  "contact.hours": "Working Hours",
  "contact.hoursValue": "Sunday - Thursday: 9:00 AM - 5:00 PM",
  "contact.followUs": "Follow Us",
  "contact.noSocial": "No social accounts have been added yet",
  "contact.formTitle": "Send Your Message",
  "contact.formDescription": "Fill in the form below and we will reply as soon as possible",
  "contact.successTitle": "Your message was sent successfully",
  "contact.successDescription": "Thank you for contacting us. We will get back to you as soon as possible.",
  "contact.name": "Full Name",
  "contact.namePlaceholder": "Mohammed Alotaibi",
  "contact.subject": "Subject",
  "contact.subjectPlaceholder": "Choose a subject",
  "contact.message": "Message",
  "contact.messagePlaceholder": "Write your message here...",
  "contact.sending": "Sending...",
  "contact.submit": "Send Message",
  "contact.submitError": "An error occurred while sending your message: {{error}}",
  "contact.country": "Country",
  "contact.chooseCountry": "Choose country",
  "contact.subjects.inquiry": "General enquiry",
  "contact.subjects.suggestion": "Suggestion",
  "contact.subjects.advertising": "Advertising request",
  "contact.subjects.partnership": "Media partnership",
  "contact.subjects.complaint": "Complaint",
  "contact.subjects.other": "Other",

  // ── Search Page ──
  "seo.search.title": "Search | Al Siyahiah",
  "seo.search.resultsTitle": "Search results for \"{{query}}\" | Al Siyahiah",
  "seo.search.description": "Search results for {{query}} in Al Siyahiah Newspaper - tourism, travel and hotel news across the Gulf.",
  "search.heroLabel": "Search Al Siyahiah",
  "search.placeholder": "Search for news, destinations, hotels...",
  "search.submit": "Search",
  "search.popularLabel": "Popular searches:",
  "search.popularSearches": ["Dubai", "Saudi tourism", "Qatar hotels", "AlUla", "Emirates Airline", "Gulf trips"],
  "search.loading": "Searching...",
  "search.resultsPrefix": "Found",
  "search.resultsSuffix": "results for",
  "search.noResultsFor": "No results for",
  "search.databaseLoading": "Searching the database...",
  "search.noResultsTitle": "No Results",
  "search.noResultsDescription": "We could not find results for \"{{query}}\". Try different keywords or browse the sections below.",
  "search.tabs.all": "All",
  "search.tabs.articles": "Articles",
  "search.tabs.videos": "Videos",
  "search.articlesTitle": "Articles and News",
  "search.videosTitle": "Videos",
  "search.viewAllArticles": "View all articles ({{count}})",
  "search.viewAllVideos": "View all videos ({{count}})",
  "search.noMatchingArticles": "No matching articles",
  "search.noMatchingVideos": "No matching videos",
  "search.relatedTags": "Related Tags",
  "search.browseCategories": "Browse Sections",
  "search.tipsTitle": "Search Tips",
  "search.tips.destination": "Search by destination: Dubai, Riyadh, Doha",
  "search.tips.hotel": "Search by hotel or airline name",
  "search.tips.category": "Search by category: aviation, hotels, destinations",
  "search.tips.languages": "Try both Arabic and English names",
  "search.statsTitle": "Search Results",
  "search.statsArticles": "Articles",
  "search.statsVideos": "Videos",
  "search.statsTotal": "Total",
  "search.startTitle": "Start Searching",
  "search.startDescription": "Type what you are looking for in the search bar above",

  // ── Category Page ──
  "seo.category.title": "{{category}} | Gulf Travel and Tourism News - Al Siyahiah",
  "seo.category.description": "Follow the latest {{category}} news in the Gulf. {{count}} news items and articles available. Al Siyahiah is the Gulf's leading tourism media platform.",
  "seo.category.keywords": "{{category}}, Gulf tourism, travel news, {{slug}}",
  "seo.category.jsonName": "{{category}} - Al Siyahiah",
  "seo.category.jsonDescription": "A collection of {{category}} articles and news in the Gulf.",
  "category.searchPlaceholder": "Search this section...",
  "category.sortLatest": "Latest",
  "category.sortPopular": "Most Read",
  "category.noResults": "No results for your search",
  "category.availableCount": "{{count}} news items and articles available in this section",
  "category.tryVisiting": "Try visiting",
  "category.toSeeAllNews": "to see all news",
  "category.pinned": "Pinned",
  "category.progress": "Showing {{shown}} of {{total}} articles",
  "category.loadingMore": "Loading...",
  "category.loadMore": "Load More",
  "category.allShown": "All articles are shown",

  // ── Videos Page SEO / labels ──
  "seo.videos.title": "Al Siyahiah Videos - Latest Gulf Tourism Reports and Footage",
  "seo.videos.description": "Watch the latest Al Siyahiah videos: field reports, exclusive tours and footage from top Gulf and international tourism destinations.",
  "seo.videos.keywords": "tourism videos, travel reports, video tours, Gulf, travel",
  "videos.heroAlt": "Al Siyahiah videos",
  "videos.featuredTitle": "Featured Videos",

  // ── PDF Edition ──
  "pdf.shareEdition": "Share Edition",
  "pdf.subscribe.title": "Subscribe to Daily Edition Alerts",
  "pdf.subscribe.description": "Get an instant email alert whenever a new Al Siyahiah daily edition is published.",
  "pdf.subscribe.successTitle": "Subscribed successfully!",
  "pdf.subscribe.successDescription": "You will receive alerts when each new edition is published.",
  "pdf.subscribe.existsTitle": "You are already subscribed!",
  "pdf.subscribe.existsDescription": "This email is already registered for edition alerts.",
  "pdf.subscribe.namePlaceholder": "Your name (optional)",
  "pdf.subscribe.submit": "Subscribe Now",
  "pdf.digitalEdition": "Digital Edition",
  "pdf.heroDescription": "Read the daily Al Siyahiah newspaper in PDF format - available to browse and download for free.",
  "pdf.latestEdition": "Latest Edition",
  "pdf.publishedToday": "Published Today",
  "pdf.editionDescription": "The daily Al Siyahiah edition - top travel and tourism news from the Gulf and the world.",
  "pdf.reads": "Reads",
  "pdf.downloads": "Downloads",
  "pdf.readNow": "Read Edition Now",
  "pdf.downloadPdf": "Download PDF",
  "pdf.noEditionsTitle": "No published editions yet",
  "pdf.noEditionsDescription": "The daily edition will be published soon",
  "pdf.archiveTitle": "Newspaper Archive",
  "pdf.archiveDescription": "Browse all previous editions of Al Siyahiah Newspaper",
  "pdf.visitArchive": "Visit Archive",
  "pdf.previousEditions": "Previous Editions",
  "pdf.editionCount": "{{count}} editions",
  "pdf.read": "Read",

  // ── Article Page ──
  "seo.article.title": "{{title}} | Al Siyahiah",
  "seo.article.keywords": "{{category}}, {{tags}}, tourism news, Gulf travel",
  "seo.article.notFoundTitle": "Article Not Found | Al Siyahiah",
  "seo.article.notFoundDescription": "The requested article does not exist in Al Siyahiah Newspaper",
  "article.notFoundTitle": "Article Not Found",
  "article.notFoundDescription": "The article may have been removed or its link changed",
  "article.likesCount": "{{count}} likes",
  "article.fallbackDetailsTitle": "Story Details",
  "article.fallbackDetailsParagraph": "This development strengthens the region's position on the global tourism map at a time when travel and tourism across the Gulf are seeing exceptional growth, supported by major investments and economic diversification plans.",
  "article.fallbackQuote": "This news reflects the strategic direction of the tourism sector, which is increasingly seen as a core pillar for economic diversification and job creation in the region.",
  "article.quoteAttribution": "- {{author}}, {{title}}",
  "article.fallbackContextTitle": "Context and Impact",
  "article.fallbackContextParagraph": "The development comes amid record growth in the Gulf tourism sector, as countries across the region continue to deliver ambitious projects that diversify income sources and reduce reliance on oil.",
  "article.fallbackParagraph": "Analysts believe that large investments in tourism infrastructure will bear fruit over the medium term, with expectations that combined Gulf tourism revenues will exceed $150 billion by 2030.",
  "article.tags": "Tags",
  "article.relatedNews": "Related News",
  "article.authorLabel": "Article Author",
  "article.authorBio": "A journalist specialized in tourism and travel news, with broad experience covering major sector events across the Gulf and the world. A regular contributor to Al Siyahiah since its founding.",
  "article.viewsLabel": "Article Views",
  "article.advertiseHere": "Advertise in this space",
  "article.trendingNow": "Most Read Now",
  "article.readAlso": "Read Also",
  "article.articleImage": "Article Image",
  "article.articleImages": "Article Images",
  "article.imageCount": "{{count}} images",
  "article.articleVideo": "Article Video",
  "article.articleVideos": "Article Videos",
  "article.imageNumber": "Image {{number}}",
  "article.lightboxHint": "Click anywhere or press Esc to close",
  "newsletter.articleDescription": "Get the top tourism news every week",

  // ── About Page ──
  "seo.about.title": "About Al Siyahiah Newspaper | Gulf Tourism Media Platform from Manama since 2011",
  "seo.about.description": "Learn about Al Siyahiah: the Gulf's leading tourism media platform since 2011, based in Manama, Kingdom of Bahrain. A team of 35 specialist journalists covers tourism and travel news across six Gulf countries.",
  "seo.about.keywords": "about Al Siyahiah, Gulf tourism newspaper, tourism media, tourism editorial team",
  "about.seoJsonName": "About Al Siyahiah Newspaper",
  "about.seoJsonDescription": "An integrated tourism media platform for the Arabian Gulf, founded in 2011.",
  "about.heroImageAlt": "About Al Siyahiah Newspaper",
  "about.badge": "About the Newspaper · Since {{year}}",
  "about.heroTitle": "Al Siyahiah Newspaper",
  "about.heroSubtitle": "A distinctive tourism media platform for the Arabian Gulf and the world",
  "about.numbers.readers": "Monthly Readers",
  "about.numbers.subscribers": "Newsletter Subscribers",
  "about.numbers.experience": "Years of Experience",
  "about.numbers.journalists": "Journalists and Editors",
  "about.numbers.countries": "Gulf Countries Covered",
  "about.numbers.advertisers": "Trusted Advertisers",
  "about.whoTitle": "Who Are We?",
  "about.content.description1": "Al Siyahiah is a daily digital media platform specialized in travel and tourism news across the Arabian Gulf and the world. Founded in 2011 in Manama, Kingdom of Bahrain, it provides professional, objective coverage of the tourism industry, from aviation and hotels to reports and economic analysis.",
  "about.content.description2": "We believe specialized tourism media plays a central role in developing the sector and supporting decision makers, investors and travelers alike. That is why we publish accurate, reliable content that reflects the real tourism landscape in the region.",
  "about.content.description3": "Al Siyahiah is powered by a team of 35 specialized journalists and editors covering major tourism events in the Gulf and globally, with an active presence at international tourism conferences and exhibitions from its headquarters in Manama, Kingdom of Bahrain.",
  "about.content.vision": "To be the first and most trusted media reference for the tourism industry in the Gulf and the Arab world.",
  "about.content.mission": "To provide specialized, objective tourism journalism that serves readers and professionals and contributes to the development of the tourism sector.",
  "about.content.values": "Objectivity, credibility, specialization and editorial independence in everything we publish.",
  "about.images.editorial": "Editorial team",
  "about.images.events": "Event coverage",
  "about.images.newsroom": "Newsroom",
  "about.images.awards": "Awards",
  "about.identityTitle": "Our Institutional Identity",
  "about.visionTitle": "Our Vision",
  "about.missionTitle": "Our Mission",
  "about.valuesTitle": "Our Values",
  "about.teamTitle": "Editorial Team",
  "about.teamDescription": "A group of journalists specialized in tourism and travel, with extensive experience in Gulf media.",
  "about.journeyTitle": "Our Journey Through the Years",
  "about.awardsTitle": "Our Awards and Achievements",
  "about.ctaTitle": "Would you like to work with us or advertise in our newspaper?",
  "about.ctaDescription": "We welcome specialist editors and correspondents, and provide advertising solutions for tourism companies.",
  "about.advertiseCta": "Advertise in Our Newspaper",
  "about.awards.1.year": "2024",
  "about.awards.1.title": "Best Tourism Media Platform",
  "about.awards.1.body": "Arab Media Award - Cairo",
  "about.awards.2.year": "2023",
  "about.awards.2.title": "Best Tourism Event Coverage",
  "about.awards.2.body": "Gulf Tourism Conference - Abu Dhabi",
  "about.awards.3.year": "2022",
  "about.awards.3.title": "Investigative Journalism",
  "about.awards.3.body": "Specialized Journalism Award - Beirut",
  "about.awards.4.year": "2021",
  "about.awards.4.title": "Best Gulf Tourism Website",
  "about.awards.4.body": "Digital Entrepreneurs Awards - Manama, Bahrain",

  "about.team.1.name": "Dr. Mohammed Al-Rashid",
  "about.team.1.role": "Editor-in-Chief",
  "about.team.1.bio": "PhD in tourism media from King Abdulaziz University. He has led the newspaper since its founding in 2011, with 20 years of experience in specialist journalism.",
  "about.team.2.name": "Reem Al-Fahad",
  "about.team.2.role": "Managing Editor",
  "about.team.2.bio": "A specialist journalist with 15 years of experience covering tourism news and luxury hotels. Winner of the Arab Tourism Journalism Award three times.",
  "about.team.3.name": "Ahmed Al-Zahrani",
  "about.team.3.role": "Aviation News Editor",
  "about.team.3.bio": "Specialized in aviation and airport news, following international conferences and exhibitions such as IATA and ATM.",
  "about.team.4.name": "Rana Al-Qahtani",
  "about.team.4.role": "Hotels and Hospitality Editor",
  "about.team.4.bio": "A hospitality critic who reviews leading hotels in the region and provides objective evaluations trusted by readers and investors.",
  "about.team.5.name": "Faisal Al-Dosari",
  "about.team.5.role": "Cultural Tourism Editor",
  "about.team.5.bio": "Specialized in heritage and cultural tourism, covering festivals and archaeological sites across Arabia and beyond.",
  "about.team.6.name": "Sami Al-Harbi",
  "about.team.6.role": "Travel Technology Editor",
  "about.team.6.bio": "An expert in tourism technology and smart travel, tracking the latest apps and digital solutions transforming traveler experiences.",
  "about.team.7.name": "Noura Al-Otaibi",
  "about.team.7.role": "Europe Correspondent",
  "about.team.7.bio": "A field correspondent based in London, covering major European tourism exhibitions and international destination reports.",
  "about.team.8.name": "Khaled Al-Mansour",
  "about.team.8.role": "Tourism Economy Editor",
  "about.team.8.bio": "An economic analyst specialized in tourism, preparing tourism investment reports and monitoring hotel performance indicators.",
  "about.milestones.1.title": "Foundation",
  "about.milestones.1.desc": "Launch of Al Siyahiah digital newspaper as the first specialized media platform for Gulf travel and tourism news.",
  "about.milestones.2.title": "First Journalism Award",
  "about.milestones.2.desc": "The newspaper won Best Tourism Media Platform at the Gulf Tourism Conference in Riyadh.",
  "about.milestones.3.title": "First International Coverage",
  "about.milestones.3.desc": "A full team covered Arabian Travel Market in Dubai for the first time with official representation.",
  "about.milestones.4.title": "Newsletter Launch",
  "about.milestones.4.desc": "Launch of the weekly newsletter, reaching 50,000 subscribers within one year.",
  "about.milestones.5.title": "Correspondent Network",
  "about.milestones.5.desc": "Expansion of the correspondent network to 12 countries and opening regional offices in Riyadh and Cairo alongside the headquarters in Manama.",
  "about.milestones.6.title": "Digital Expansion",
  "about.milestones.6.desc": "Launch of the smart app and social media accounts, exceeding 500,000 followers in the first year.",
  "about.milestones.7.title": "One Million Readers",
  "about.milestones.7.desc": "Monthly readership passed one million, alongside the launch of the interactive GCC Tourism Guide.",
  "about.milestones.8.title": "Integrated Platform",
  "about.milestones.8.desc": "The platform relaunched with its new identity from Manama, Kingdom of Bahrain, offering integrated media services for the Gulf tourism sector.",

  // ── Advertising Page ──
  "seo.advertising.title": "Advertise in Al Siyahiah | Gulf Tourism Advertising Solutions | 2.5M+ Readers",
  "seo.advertising.description": "Advertise in Al Siyahiah Newspaper and reach more than 2.5 million monthly readers interested in tourism and travel across the Gulf. Advertising packages include banners, sponsored articles and newsletters.",
  "seo.advertising.keywords": "tourism advertising, tourism marketing, Gulf ads, advertising packages, tourism platform",
  "advertising.schemaName": "Advertising Services at Al Siyahiah Newspaper",
  "advertising.schemaDescription": "Specialized advertising services for the Gulf tourism and travel sector.",
  "advertising.heroAlt": "Advertising in Al Siyahiah",
  "advertising.heroTitle": "Advertise in Al Siyahiah Newspaper",
  "advertising.heroDescription": "Reach millions of readers interested in travel and tourism across the Arabian Gulf through our leading media platform.",
  "advertising.viewPackages": "View Packages",
  "advertising.stats.readers": "Monthly Readers",
  "advertising.stats.subscribers": "Newsletter Subscribers",
  "advertising.stats.countries": "Gulf Countries",
  "advertising.stats.satisfaction": "Advertiser Satisfaction",
  "advertising.credentials.award": "Best Gulf Tourism Media Platform 2025",
  "advertising.credentials.member": "Member of the Arab Press Federation",
  "advertising.credentials.coverage": "Coverage in 40+ countries worldwide",
  "advertising.credentials.team": "Editorial team of 35 specialist journalists",
  "advertising.formatsTitle": "Available Advertising Options",
  "advertising.formatsDescription": "We provide diverse media solutions for every marketing objective and budget.",
  "advertising.adFormats.banner.title": "Banner Ads",
  "advertising.adFormats.banner.description": "Visual ads in premium page placements using standard IAB sizes.",
  "advertising.adFormats.banner.details": "728x90 | 300x250 | 160x600 | 320x50",
  "advertising.adFormats.sponsored.title": "Sponsored Articles",
  "advertising.adFormats.sponsored.description": "Professional editorial content integrated into the news context for stronger engagement.",
  "advertising.adFormats.sponsored.details": "Written by a specialized editorial team",
  "advertising.adFormats.newsletter.title": "Newsletter",
  "advertising.adFormats.newsletter.description": "Integrated ads in the weekly newsletter reaching more than 85,000 subscribers.",
  "advertising.adFormats.newsletter.details": "Weekly newsletter - every Wednesday",
  "advertising.adFormats.events.title": "Event Coverage",
  "advertising.adFormats.events.description": "Comprehensive media coverage for your tourism events with professional photos and reports.",
  "advertising.adFormats.events.details": "Conferences | Exhibitions | Openings",
  "advertising.adFormats.social.title": "Social Media",
  "advertising.adFormats.social.description": "Promotion through our social media accounts with active followers.",
  "advertising.adFormats.social.details": "+500K followers across all platforms",
  "advertising.adFormats.editorial.title": "Editorial Visibility",
  "advertising.adFormats.editorial.description": "Place your organization within specialized reports and editorial reviews.",
  "advertising.adFormats.editorial.details": "Hotel reviews | Destination reports",
  "advertising.pricingTitle": "Advertising Packages",
  "advertising.pricingDescription": "Transparent, fair pricing with guaranteed access to your target audience.",
  "advertising.mostRequested": "Most Requested",
  "advertising.impressions": "impressions",
  "advertising.packageCta": "Choose This Package",
  "advertising.pricingNote": "All prices are negotiable for annual contracts · VAT applies",
  "advertising.whyImageAlt": "Why advertise in Al Siyahiah",
  "advertising.whyTitle": "Why choose advertising in Al Siyahiah Newspaper?",
  "advertising.whyDescription": "We are the leading specialized tourism and travel media platform in the Gulf, reaching an engaged audience with genuine interest in the tourism sector.",
  "advertising.why.audience.title": "Specialized, Qualified Audience",
  "advertising.why.audience.desc": "Our readers are travel and tourism enthusiasts and sector decision makers.",
  "advertising.why.coverage.title": "Wide Gulf Geographic Coverage",
  "advertising.why.coverage.desc": "Strong presence across the UAE, Saudi Arabia, Qatar, Kuwait, Bahrain and Oman.",
  "advertising.why.results.title": "Measurable Results",
  "advertising.why.results.desc": "Detailed reports for every campaign: views, clicks and engagement rates.",
  "advertising.why.credibility.title": "Established Media Credibility",
  "advertising.why.credibility.desc": "15+ years in specialist tourism journalism gives your ad real credibility.",
  "advertising.trustedTitle": "Trusted by more than 200 advertisers",
  "advertising.faqTitle": "Frequently Asked Questions",
  "advertising.faq.custom.q": "Can the package be customized to my budget?",
  "advertising.faq.custom.a": "Yes. Our advertising team works with you to design a flexible plan that fits your budget and marketing goals.",
  "advertising.faq.launch.q": "How long does it take to launch an ad campaign?",
  "advertising.faq.launch.a": "Campaigns usually start within 48 hours after confirming the request and completing payment.",
  "advertising.faq.annual.q": "Are annual contract offers available?",
  "advertising.faq.annual.a": "Yes. We offer discounts of up to 25% for annual contracts. Contact us for details.",
  "advertising.faq.payment.q": "What payment methods are available?",
  "advertising.faq.payment.a": "We accept bank transfers, credit cards and purchase orders for large companies.",
  "advertising.contactTitle": "Contact the Advertising Department",
  "advertising.contactDescription": "Our specialist media team is ready to design a custom advertising plan that fits your marketing goal and budget.",
  "advertising.adPhone": "Advertising Department Phone",
  "advertising.hoursValue": "Sunday - Thursday: 9 AM - 6 PM",
  "advertising.consultantTitle": "Speak with an advertising consultant now",
  "advertising.consultantDescription": "Free consultation within 24 hours",
  "advertising.startNow": "Start Now",
  "advertising.thanksTitle": "Thank you for contacting us!",
  "advertising.thanksDescription": "The advertising manager will contact you within 24 working hours.",
  "advertising.submitError": "Could not send your request. Please try again.",
  "advertising.formTitle": "Send Advertising Request",
  "advertising.formDescription": "We receive your request directly and contact you within 24 hours.",
  "advertising.companyInfo": "Company Information",
  "advertising.companyName": "Company / Organization Name",
  "advertising.companyPlaceholder": "Your company name",
  "advertising.phoneWhatsapp": "Phone / WhatsApp",
  "advertising.website": "Website",
  "advertising.campaignDetails": "Campaign Details",
  "advertising.adType": "Requested ad type",
  "advertising.chooseType": "Choose type",
  "advertising.types.banner": "Banner ad",
  "advertising.types.sponsored": "Sponsored editorial article",
  "advertising.types.newsletter": "Newsletter",
  "advertising.types.events": "Event coverage",
  "advertising.types.social": "Social media",
  "advertising.types.package": "Full package",
  "advertising.packageInterested": "Package of interest",
  "advertising.choosePackage": "Choose package (optional)",
  "advertising.budget": "Expected monthly budget",
  "advertising.chooseRange": "Choose range",
  "advertising.budgets.under": "Under BHD 200",
  "advertising.budgets.low": "BHD 200 - 500",
  "advertising.budgets.mid": "BHD 500 - 1,500",
  "advertising.budgets.high": "Over BHD 1,500",
  "advertising.duration": "Requested campaign duration",
  "advertising.chooseDuration": "Choose duration",
  "advertising.durations.week": "1 week",
  "advertising.durations.twoWeeks": "2 weeks",
  "advertising.durations.month": "1 month",
  "advertising.durations.twoMonths": "2 months",
  "advertising.durations.threeMonths": "3 months",
  "advertising.durations.sixMonths": "6 months",
  "advertising.durations.year": "Full year",
  "advertising.targetAudience": "Target audience",
  "advertising.targetPlaceholder": "Example: Gulf families, business travelers, European tourists...",
  "advertising.extraDetails": "Additional campaign details",
  "advertising.messagePlaceholder": "Tell us about your advertising goal and any details you want to share...",
  "advertising.submit": "Send Advertising Request",
  "advertising.finalTitle": "Start connecting with Al Siyahiah readers",
  "advertising.finalDescription": "Join more than 200 tourism companies advertising in our newspaper to reach their specialist audience.",
  "advertising.contactNow": "Contact Us Now",

  // ── GCC Guide Page ──
  "seo.gccGuide.title": "GCC Tourism Guide | Hotels, Restaurants and Attractions in {{country}} - Al Siyahiah",
  "seo.gccGuide.description": "A comprehensive GCC tourism guide: the best hotels, restaurants and attractions in {{country}}. Discover selected Gulf tourism destinations.",
  "seo.gccGuide.keywords": "GCC tourism guide, Gulf hotels, Gulf restaurants, tourist attractions, UAE tourism, Saudi tourism",
  "gccGuide.gulf": "the Gulf",
  "gccGuide.allCountries": "the UAE, Saudi Arabia, Qatar, Kuwait, Bahrain and Oman",
  "gccGuide.schemaName": "GCC Tourism Guide - Al Siyahiah",
  "gccGuide.schemaDescription": "A comprehensive tourism guide for the Arabian Gulf, featuring top hotels, restaurants and attractions.",
  "gccGuide.types.hotels": "Hotels",
  "gccGuide.types.restaurants": "Restaurants",
  "gccGuide.types.attractions": "Attractions",
  "gccGuide.types.tripPlanner": "Plan Your Trip",
  "gccGuide.typeSingular.hotel": "Hotel",
  "gccGuide.typeSingular.restaurant": "Restaurant",
  "gccGuide.typeSingular.attraction": "Attraction",
  "gccGuide.chooseCountry": "Choose country",
  "gccGuide.highlights": "Top highlights",
  "gccGuide.budget": "Budget",
  "gccGuide.budgetFilters.0": "All",
  "gccGuide.budgetFilters.1": "Budget",
  "gccGuide.budgetFilters.2": "Mid-range",
  "gccGuide.budgetFilters.3": "Luxury",
  "gccGuide.travellerType": "Traveler type",
  "gccGuide.travellerFilters.0": "All",
  "gccGuide.travellerFilters.1": "Family",
  "gccGuide.travellerFilters.2": "Romantic",
  "gccGuide.travellerFilters.3": "Solo",
  "gccGuide.travellerFilters.4": "Groups",
  "gccGuide.search": "Search",
  "gccGuide.searchPlaceholder": "Search for a hotel or restaurant...",
  "gccGuide.planTripIn": "Plan your trip in {{country}}",
  "gccGuide.planTripDescription": "Plan your trip day by day, choose hotels, restaurants and attractions, and export a print-ready PDF itinerary.",
  "gccGuide.startPlanning": "Start Planning Now",
  "gccGuide.noResultsTitle": "No Results",
  "gccGuide.noResultsDescription": "Try changing the filters or using a different search term",
  "gccGuide.resetFilters": "Reset Filters",
  "gccGuide.inDevelopment": "In Development",
  "gccGuide.comingSoon": "{{country}} listings will be added soon",
  "gccGuide.locationMap": "Location Map",
  "gccGuide.mapTitle": "{{country}} map",
  "gccGuide.exploreOtherCountries": "Explore Other GCC Countries",
  "gccGuide.backToGuide": "Back to GCC Guide",
  "seo.gccListing.title": "{{name}} | {{type}} {{country}} - Al Siyahiah",
  "seo.gccListing.defaultTitle": "Place Details - Al Siyahiah",
  "seo.gccListing.description": "{{name}} in {{location}}. Rated {{rating}}/5 by {{reviews}} visitors. {{price}}. Explore details, photos and reviews.",
  "seo.gccListing.keywords": "{{name}}, {{location}}, {{category}}, GCC guide",
  "gccGuide.countryNews.title": "{{country}} News",
  "gccGuide.countryNews.newsCount": "{{count}} news items",
  "gccGuide.countryNews.categories.all": "All",
  "gccGuide.countryNews.categories.aviation": "Aviation",
  "gccGuide.countryNews.categories.hotels": "Hotels",
  "gccGuide.countryNews.categories.destinations": "Destinations",
  "gccGuide.countryNews.categories.events": "Events",
  "gccGuide.countryNews.categories.reports": "Reports",
  "gccGuide.countryNews.noCategoryNews": "No news in this category",
  "gccGuide.countryNews.noMoreNews": "No additional news",
  "gccGuide.countryNews.stats.published": "Published News",
  "gccGuide.countryNews.stats.views": "Total Views",
  "gccGuide.countryNews.stats.featured": "Featured News",
  "gccGuide.listing.notFoundTitle": "Place Not Found",
  "gccGuide.listing.notFoundDescription": "We could not find this place",
  "gccGuide.listing.selected": "Selected",
  "gccGuide.listing.featured": "Featured",
  "gccGuide.listing.reviewsCount": "{{count}} reviews",
  "gccGuide.listing.tabs.overview": "Overview",
  "gccGuide.listing.tabs.gallery": "Photos",
  "gccGuide.listing.tabs.reviews": "Reviews",
  "gccGuide.listing.tabs.map": "Location",
  "gccGuide.listing.aboutTitle": "About this place",
  "gccGuide.listing.fallbackAbout.1": "is one of the notable tourism destinations in {{location}}, combining local character with a modern visitor experience. Its location and services make it suitable for different traveler needs and tastes.",
  "gccGuide.listing.fallbackAbout.2": "The team focuses on delivering a polished visitor experience with attention to details that improve guest satisfaction. The place is highly rated, with scores above {{rating}} out of 5 stars.",
  "gccGuide.listing.amenitiesTitle": "Amenities and Services",
  "gccGuide.listing.openingHours": "Opening Hours",
  "gccGuide.listing.days.sunThu": "Sunday - Thursday",
  "gccGuide.listing.days.friday": "Friday",
  "gccGuide.listing.days.saturday": "Saturday",
  "gccGuide.listing.defaultHours.sunThu": "9:00 AM - 11:00 PM",
  "gccGuide.listing.defaultHours.friday": "2:00 PM - 12:00 AM",
  "gccGuide.listing.defaultHours.saturday": "10:00 AM - 12:00 AM",
  "gccGuide.listing.galleryTitle": "Photo Gallery",
  "gccGuide.listing.photosCount": "{{count}} photos",
  "gccGuide.listing.mapTitle": "Location on Map",
  "gccGuide.listing.mapIframeTitle": "{{name}} location",
  "gccGuide.listing.openInGoogleMaps": "Open in Google Maps",
  "gccGuide.listing.price": "Price",
  "gccGuide.listing.rating": "Rating",
  "gccGuide.listing.reviewCount": "Review Count",
  "gccGuide.listing.location": "Location",
  "gccGuide.listing.category": "Category",
  "gccGuide.listing.website": "Website",
  "gccGuide.listing.viewOnMap": "View on Map",
  "gccGuide.listing.country": "Country",
  "gccGuide.listing.similarPlaces": "Similar Places",
  "gccGuide.listing.amenities.freeWifi": "Free Wi-Fi",
  "gccGuide.listing.amenities.pool": "Pool",
  "gccGuide.listing.amenities.restaurant": "Restaurant",
  "gccGuide.listing.amenities.gym": "Gym",
  "gccGuide.listing.amenities.roomService": "Room service",
  "gccGuide.listing.amenities.parking": "Parking",
  "gccGuide.listing.amenities.spa": "Spa",
  "gccGuide.listing.amenities.businessCenter": "Business center",
  "gccGuide.listing.amenities.reservations": "Reservations",
  "gccGuide.listing.amenities.takeaway": "Takeaway",
  "gccGuide.listing.amenities.delivery": "Delivery",
  "gccGuide.listing.amenities.vegetarianMenu": "Vegetarian menu",
  "gccGuide.listing.amenities.familyFriendly": "Family friendly",
  "gccGuide.listing.amenities.liveMusic": "Live music",
  "gccGuide.listing.amenities.tourGuide": "Tour guide",
  "gccGuide.listing.amenities.giftShop": "Gift shop",
  "gccGuide.listing.amenities.onsiteRestaurant": "On-site restaurant",
  "gccGuide.listing.amenities.kidFriendly": "Kid friendly",
  "gccGuide.listing.amenities.accessible": "Accessible",
  "gccGuide.gallery.mainImageAlt": "{{name}} - main image",
  "gccGuide.gallery.imageAlt": "{{name}} - image {{number}}",
  "gccGuide.reviews.title": "Visitor Reviews",
  "gccGuide.reviews.rating.1": "Poor",
  "gccGuide.reviews.rating.2": "Fair",
  "gccGuide.reviews.rating.3": "Good",
  "gccGuide.reviews.rating.4": "Very Good",
  "gccGuide.reviews.rating.5": "Excellent",
  "gccGuide.reviews.scores.location": "Location",
  "gccGuide.reviews.scores.cleanliness": "Cleanliness",
  "gccGuide.reviews.scores.service": "Service",
  "gccGuide.reviews.scores.value": "Value",
  "gccGuide.reviews.helpful": "Helpful ({{count}})",
  "gccGuide.reviews.loadMore": "Show More Reviews",
  "gccGuide.reviews.1.author": "Mohammed Al-Omari",
  "gccGuide.reviews.1.date": "March 2025",
  "gccGuide.reviews.1.text": "An exceptional experience at {{name}}. The service was excellent, the team was helpful, and the place was clean and well organized. I would return and recommend it to visitors in the area.",
  "gccGuide.reviews.2.author": "Sara Al-Khaldi",
  "gccGuide.reviews.2.date": "February 2025",
  "gccGuide.reviews.2.text": "I visited {{name}} with my family and we had a lovely experience. The children enjoyed it, and the prices felt fair for the quality provided. It can get busy on weekends.",
  "gccGuide.reviews.3.author": "Khaled Al-Mansouri",
  "gccGuide.reviews.3.date": "January 2025",
  "gccGuide.reviews.3.text": "One of the best places I visited in the area. The quality exceeded expectations and the details show real care for guests. Booking ahead is recommended for the best experience.",
  "gccGuide.reviews.4.author": "Noura Al-Saeed",
  "gccGuide.reviews.4.date": "December 2024",
  "gccGuide.reviews.4.text": "A great experience overall. The location is ideal and the facilities are excellent. I only wish the opening hours were a little longer. I would visit again on my next trip.",
  "gccGuide.reviews.5.author": "Abdullah Al-Rashed",
  "gccGuide.reviews.5.date": "November 2024",
  "gccGuide.reviews.5.text": "A memorable visit. Everything was smooth from arrival to departure, and the refined service made the experience stand out.",
  "gccGuide.reviews.tags.excellentService": "Excellent service",
  "gccGuide.reviews.tags.clean": "Very clean",
  "gccGuide.reviews.tags.greatLocation": "Great location",
  "gccGuide.reviews.tags.familyFriendly": "Family friendly",
  "gccGuide.reviews.tags.fairPrices": "Fair prices",
  "gccGuide.reviews.tags.enjoyable": "Enjoyable experience",
  "gccGuide.reviews.tags.highQuality": "High quality",
  "gccGuide.reviews.tags.worthVisiting": "Worth visiting",
  "gccGuide.reviews.tags.professional": "Professional",
  "gccGuide.reviews.tags.perfectLocation": "Perfect location",
  "gccGuide.reviews.tags.excellentFacilities": "Excellent facilities",
  "gccGuide.reviews.tags.refinedService": "Refined service",
  "gccGuide.reviews.tags.memorable": "Memorable experience",
  "gccGuide.reviews.tags.greatTeam": "Great team",

  // ── Trip Planner ──
  "seo.tripPlanner.title": "Plan Your Gulf Trip | GCC Guide - Al Siyahiah",
  "seo.tripPlanner.description": "Plan your trip across the Arabian Gulf. Choose hotels, restaurants and attractions, then export your itinerary as a PDF.",
  "seo.tripPlanner.keywords": "Gulf trip planner, plan your trip, GCC tourism, travel itinerary",
  "tripPlanner.title": "Plan Your Trip",
  "tripPlanner.heroTitle": "Plan Your Trip",
  "tripPlanner.heroDescription": "Choose your destination and trip duration, add hotels, restaurants and attractions, then export your plan as a PDF or save it for later.",
  "tripPlanner.savedTrips": "Saved Trips",
  "tripPlanner.newTrip": "New Trip",
  "tripPlanner.clearAll": "Clear All",
  "tripPlanner.updateTrip": "Update Trip",
  "tripPlanner.saveTrip": "Save Trip",
  "tripPlanner.update": "Update",
  "tripPlanner.editing": "Editing:",
  "tripPlanner.tripInfo": "Trip Information",
  "tripPlanner.tripName": "Trip Name",
  "tripPlanner.tripNamePlaceholder": "Example: Dubai summer trip",
  "tripPlanner.tripNamePlaceholderLong": "Example: Dubai summer trip 2025",
  "tripPlanner.travelerName": "Traveler Name",
  "tripPlanner.travelerNamePlaceholder": "Your name or group name",
  "tripPlanner.updateSavedTrip": "Update Saved Trip",
  "tripPlanner.destination": "Destination",
  "tripPlanner.duration": "Trip Duration",
  "tripPlanner.durationWarning": "Warning: activities exist from day {{from}} to {{to}}",
  "tripPlanner.daysCount": "{{count}} day",
  "tripPlanner.daysCount_plural": "{{count}} days",
  "tripPlanner.tripDurationPrefix": "Trip duration:",
  "tripPlanner.inDestination": "in {{country}}",
  "tripPlanner.selectedDestination": "the selected destination",
  "tripPlanner.durationAffectedHint": "Orange buttons contain activities that will be affected",
  "tripPlanner.tripSummary": "Trip Summary",
  "tripPlanner.stats.days": "Number of Days",
  "tripPlanner.stats.activities": "Total Activities",
  "tripPlanner.availableIn": "Available in {{country}}",
  "tripPlanner.schedule": "Schedule",
  "tripPlanner.map": "Trip Map",
  "tripPlanner.addDayHint": "Click any day to add activities",
  "tripPlanner.noActivitiesTitle": "No activities yet",
  "tripPlanner.noActivitiesMapDescription": "Add activities from the schedule tab to show them on the map",
  "tripPlanner.goToSchedule": "Go to Schedule",
  "tripPlanner.readyTitle": "Your trip is ready!",
  "tripPlanner.readyDescription": "You have {{activities}} activities across {{days}} days in {{country}}",
  "tripPlanner.shareTrip": "Share Trip",
  "tripPlanner.toast.durationReducedMoved": "Trip reduced to {{duration}} days and activities were moved",
  "tripPlanner.toast.durationReduced": "Trip reduced to {{duration}} days",
  "tripPlanner.toast.updated": "Trip updated successfully",
  "tripPlanner.toast.updateError": "An error occurred while updating",
  "tripPlanner.toast.saved": "Trip saved successfully",
  "tripPlanner.toast.saveError": "An error occurred while saving",
  "tripPlanner.toast.loaded": "Loaded trip \"{{name}}\"",
  "tripPlanner.toast.deleted": "Trip deleted",
  "tripPlanner.toast.newTrip": "New trip created",
  "tripPlanner.myTrip": "My Trip",
  "tripPlanner.saveModal.saveDescription": "Save your trip to return to it later",
  "tripPlanner.saveModal.updateDescription": "Update the current trip details",
  "tripPlanner.saveModal.browserNote": "Your trip will be saved automatically in this browser. You can return to it anytime from Saved Trips.",
  "tripPlanner.saveModal.saving": "Saving...",
  "tripPlanner.addItem.title": "Add Activity to Trip",
  "tripPlanner.addItem.searchPlaceholder": "Search by name or location...",
  "tripPlanner.shareModal.shareText": "See my trip plan to {{country}}{{name}} via the GCC Tourism Guide!",
  "tripPlanner.shareModal.subtitle": "Send your trip link to friends",
  "tripPlanner.shareModal.saveFirstTitle": "Save the trip first",
  "tripPlanner.shareModal.saveFirstDescription": "To share your trip, save it first so your friends can view it.",
  "tripPlanner.shareModal.saveNow": "Save Trip Now",
  "tripPlanner.shareModal.uniqueLink": "{{country}} - unique sharing link",
  "tripPlanner.shareModal.shareLink": "Share Link",
  "tripPlanner.shareModal.shareVia": "Share via",
  "tripPlanner.shareModal.nativeShare": "Share through other apps",
  "tripPlanner.shareModal.linkPrivacy": "Anyone with this link can view your trip. They cannot edit it.",
  "tripPlanner.dayNumber": "Day {{number}}",
  "tripPlanner.dayMapTitle": "Day {{number}} - Map",
  "tripPlanner.activitiesCount": "{{count}} activity",
  "tripPlanner.activitiesCount_plural": "{{count}} activities",
  "tripPlanner.mapLocationsCount": "{{count}} map location",
  "tripPlanner.mapLocationsCount_plural": "{{count}} map locations",
  "tripPlanner.allLocations": "All ({{count}})",
  "tripPlanner.noDayActivities": "No activities for this day",
  "tripPlanner.openInGoogleMaps": "Open in Google Maps",
  "tripPlanner.mapIframeTitle": "Day {{number}} map",
  "tripPlanner.dragActivity": "Drag to move activity",
  "tripPlanner.notePlaceholder": "Note (optional)...",
  "tripPlanner.moving": "Moving...",
  "tripPlanner.moreActivities": "{{count}} more activities",
  "tripPlanner.reorderDay": "Drag to reorder day",
  "tripPlanner.dragActivities": "Drag activities to move",
  "tripPlanner.addActivity": "Add Activity",
  "tripPlanner.dropHereMove": "Drop here to move activity",
  "tripPlanner.emptyDayHint": "Click to add a hotel, restaurant or attraction",
  "tripPlanner.dropHere": "Drop here",
  "tripPlanner.savedPanel.emptyTitle": "No saved trips yet",
  "tripPlanner.savedPanel.emptyDescription": "Save your current trip to find it here",
  "tripPlanner.savedPanel.current": "Current",
  "tripPlanner.savedPanel.load": "Load trip",
  "tripPlanner.savedPanel.confirmDelete": "Confirm delete",
  "tripPlanner.savedPanel.delete": "Delete trip",
  "tripPlanner.durationModal.title": "Change Trip Duration",
  "tripPlanner.durationModal.fromTo": "From {{from}} to {{to}} days",
  "tripPlanner.durationModal.warningTitle": "{{count}} activities exist in removed days",
  "tripPlanner.durationModal.warningDescription": "Days {{from}} to {{to}} contain activities. What would you like to do with them?",
  "tripPlanner.durationModal.moveToDay": "Move activities to day {{day}}",
  "tripPlanner.durationModal.moveDescription": "All activities from removed days will be moved to the final day in the new trip.",
  "tripPlanner.durationModal.discardTitle": "Delete extra activities",
  "tripPlanner.durationModal.discardDescription": "{{count}} activities will be permanently removed from deleted days.",
  "tripPlanner.durationModal.cancel": "Cancel - keep {{duration}} days",
  "seo.sharedTrip.title": "{{name}} | GCC Guide - Al Siyahiah",
  "seo.sharedTrip.defaultTitle": "Shared Trip | GCC Guide",
  "seo.sharedTrip.description": "Trip plan to {{country}} for {{duration}} days with {{activities}} tourism activities.",
  "seo.sharedTrip.defaultDescription": "View a tourism trip plan across GCC countries",
  "seo.sharedTrip.keywords": "trip plan, GCC tourism, tourism guide",
  "tripPlanner.shared.loading": "Loading trip...",
  "tripPlanner.shared.notFoundTitle": "Trip Not Found",
  "tripPlanner.shared.notFoundDescription": "This link is invalid or the trip was deleted by its owner.",
  "tripPlanner.shared.createOwn": "Plan Your Own Trip",
  "tripPlanner.shared.sharedTrip": "Shared Trip",
  "tripPlanner.shared.createOwnTitle": "Plan your own trip!",
  "tripPlanner.shared.createOwnDescription": "Like this trip? Plan your own Gulf trip now.",
  "tripPlanner.shared.startPlanning": "Start Planning",
  "tripPlanner.shared.shareText": "See the trip plan \"{{name}}\" to {{country}}",
  "tripPlanner.shared.shortShareText": "See the trip plan \"{{name}}\"",
  "tripPlanner.pdf.scanToShare": "Scan the code to share the trip",
  "tripPlanner.pdf.coverStats": "{{days}} days | {{activities}} activities",
  "tripPlanner.pdf.preparedFor": "Prepared for: {{name}}",
  "tripPlanner.pdf.scanDescription": "Scan the QR code to open the trip plan and share it with friends and family",
  "tripPlanner.pdf.allActivities": "All Activities",
  "tripPlanner.pdf.exporting": "Exporting...",
  "tripPlanner.pdf.export": "Export PDF",
  "tripPlanner.pdf.travelTipsFor": "Travel tips for {{country}}",
  "tripPlanner.pdf.importantInfo": "Important information before you travel",
  "tripPlanner.pdf.currency": "Currency",
  "tripPlanner.pdf.language": "Language",
  "tripPlanner.pdf.timezone": "Time zone",
  "tripPlanner.pdf.bestSeason": "Best season",
  "tripPlanner.pdf.emergency": "Emergency",
  "tripPlanner.pdf.visa": "Visa",
  "tripPlanner.pdf.importantTips": "Important traveler tips",
  "tripPlanner.pdf.do": "Do",
  "tripPlanner.pdf.dont": "Avoid",
  "tripPlanner.pdf.usefulPhrases": "Useful phrases",

  // ── Opinion Pages ──
  "seo.opinionList.title": "Opinion Articles | Al Siyahiah",
  "seo.opinionList.description": "Opinion articles and analysis in Al Siyahiah Newspaper - views from leading writers and analysts in tourism and travel.",
  "seo.opinionList.keywords": "opinion articles, tourism analysis, opinion, tourism, travel, Gulf",
  "seo.opinionArticle.title": "Opinion Article | Al Siyahiah",
  "seo.opinionArticle.detailTitle": "{{title}} | Opinion Articles | Al Siyahiah",
  "seo.opinionArticle.description": "Opinion articles in Al Siyahiah Newspaper",
  "seo.opinionArticle.keywords": "opinion articles, {{author}}, tourism, opinion",
  "opinion.specialSection": "Special Section",
  "opinion.listSubtitle": "Views and analysis from leading writers and analysts in tourism and travel - deep insight and informed perspectives.",
  "opinion.authorCount": "{{count}} writers",
  "opinion.searchPlaceholder": "Search opinion articles...",
  "opinion.noArticles": "No opinion articles",
  "opinion.notFoundTitle": "Article Not Found",
  "opinion.notFoundDescription": "The article may have been removed or its link changed",
  "opinion.articleBadge": "Opinion Article",
  "opinion.likesCount": "{{count}} likes",
  "opinion.defaultAuthorBio": "A writer specialized in tourism and travel, sharing insights and analysis in Al Siyahiah Newspaper.",
  "opinion.otherArticles": "Other Opinion Articles",
  "opinion.articleStats": "Article Statistics",
  "opinion.views": "Views",
  "opinion.likes": "Likes",
  "opinion.wordCount": "Word Count",
  "opinion.wordsCount": "{{count}} words",
  "opinion.readingTime": "Reading Time",
  "opinion.minutesCount": "{{count}} min",
  "opinion.newsletterDescription": "Get the top opinion articles every week",
};

export default en;
